import type {ReactElement} from 'react';
import React, {useCallback, useState} from 'react';
import {InputField} from '@Components/input-field-v2';
import {disableNextButton, enableNextButton, updatePinterestPublishingParamsWebsiteLink} from '@Components/social-media-wizard/social-media-wizard-reducer';
import type {SocialAccount} from '@Components/social-media/account.vo';
import type {PinterestPublishingParams} from '@Components/social-media/publish-params.types';
import type {InputType} from '@Components/input-field-v2/input-field.types';
import {isValidURL} from '@Utils/url.util';
import {ErrorBox} from '@Components/error-box';
import {useAppDispatch, useAppSelector} from '@/hooks';
import styles from './pinterest-website-link.module.scss';

interface PinterestWebsiteLinkProps {
  account: SocialAccount;
}

export function PinterestWebsiteLink({...props}: PinterestWebsiteLinkProps): ReactElement<any> {
  const [linkErrorState, setLinkErrorState] = useState(false);
  const dispatch = useAppDispatch();

  const setPinterestWebsiteLink = useCallback((value: string): void => {
    if (isValidURL(value) || value === '') {
      setLinkErrorState(false);
      dispatch(enableNextButton());
    } else {
      setLinkErrorState(true);
      dispatch(disableNextButton());
    }

    dispatch(updatePinterestPublishingParamsWebsiteLink({websiteLink: value, idSocialMediaAccount: props.account.id}));
  }, []);

  const pinterestPublishingParams: PinterestPublishingParams = useAppSelector((state) => {
    return state.socialMediaWizard.publishingParams[props.account.id].POST as PinterestPublishingParams;
  });

  const getErrorMessage = (): ReactElement<any> | null => {
    if (!linkErrorState) {
      return null;
    }

    return <ErrorBox title="" description={window.i18next.t('pmwjs_please_enter_a_valid_link')} isPlain />;
  };

  return (
    <>
      <InputField
        input={(pinterestPublishingParams?.websiteLink ?? '') as InputType}
        onInputChange={setPinterestWebsiteLink}
        className={`${styles.websiteLink} ${linkErrorState ? styles.linkError : null}`}
        inputClassName={`${styles.noBorder}`}
        placeholder={window.i18next.t('pmwjs_website_link')}
        hasIcon="icon-link"
      />
      {getErrorMessage()}
    </>
  );
}
